import BatchSenderAbi from "../abis/BatchSender.json";

export interface ContractSetup {
  address: string;
  abi: any[];
}

export const DAI_CONTRACT: { [chainId: number]: ContractSetup } = {
  1: {
    address: "0x6b175474e89094c44da98b954eedeac495271d0f",
    abi: [
      {
        constant: true,
        inputs: [{ name: "src", type: "address" }],
        name: "balanceOf",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
      },
      {
        constant: false,
        inputs: [
          { name: "dst", type: "address" },
          { name: "wad", type: "uint256" },
        ],
        name: "transfer",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
      },
    ],
  },
};


export const DOGIEFIGHTER_CONTRACT: { [chainId: number]: ContractSetup } = {
  4: {
    address: "0xCe46909BDF13b6E4DCDa0D2259Dfa9cf78574a4c",
    abi: [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "account", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" }], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256[]", "name": "ids", "type": "uint256[]" }, { "indexed": false, "internalType": "uint256[]", "name": "values", "type": "uint256[]" }], "name": "TransferBatch", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "id", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "TransferSingle", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "string", "name": "value", "type": "string" }, { "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "URI", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address[]", "name": "accounts", "type": "address[]" }, { "internalType": "uint256[]", "name": "ids", "type": "uint256[]" }], "name": "balanceOfBatch", "outputs": [{ "internalType": "uint256[]", "name": "", "type": "uint256[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "exists", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" }], "name": "isApprovedForAll", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "mint", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256[]", "name": "ids", "type": "uint256[]" }, { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "mintBatch", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256[]", "name": "ids", "type": "uint256[]" }, { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "safeBatchTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "newuri", "type": "string" }], "name": "setURI", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes4", "name": "interfaceId", "type": "bytes4" }], "name": "supportsInterface", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "tokenCounter", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "tokenIdToBreed", "outputs": [{ "internalType": "enum DogieFighter.Breed", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "uri", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }]
  }
};


export const BATCHSENDER_CONTRACT: { [chainId: number]: ContractSetup } = {
  1: {  // Mainnet
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  3: {  // Ropsten
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    // address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    // address: '0xeD1f46E635e43289D69932F06A13006df0e53B57',
    abi: BatchSenderAbi.abi
  },
  4: {  // Rinkeby
    address: '0xb867eF31B2f5a7aa09eCfb9470B7b4f2f50592E6',
    // address: '0x3B3F82A20eDb60c2401f120855F7C02Ea290B66C',
    abi: BatchSenderAbi.abi
  },
  5: {  // Goerli
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  42: {  // Kovan
    address: '0x5aa4eea9bf9b8c5993a2c4067ec51da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  56: {  // BSC
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  97: {  // BSC Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  137: {  // Polygon
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  80001: {  // Polygon Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  43114: {  // Avalanche
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  43113: {  // Avalanche Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  250: {  // Fantom Opera
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  4002: {  // Fantom Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  128: {  // Heco Mainnet
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  256: {  // Heco Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  25: {  // Cronos Mainnet
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  10: {  // Optimism
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  420: {  // Optimism Goerli
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  42161: {  // Arbitrum
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  421611: {  // Arbitrum Rinkeby
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  8217: {  // Klaytn
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  1001: {  // Klaytn Testnet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  100: {  // Gnosis
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  1313161554: {  // Aurora
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  42220: {  // Celo
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  32659: {  // Fusion
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  1284: {  // Moonbeam
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  1285: {  // Moonriver
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  1287: {  // Moonbase Alphanet
    address: '0x5aa4Eea9bF9B8C5993a2c4067Ec51Da75e3826eb',
    abi: BatchSenderAbi.abi
  },
  10001: {  // ETHW
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
  513100: {  // ETHF
    address: '0xBA6bba18d0711676175bA1464991980D12C7585C',
    abi: BatchSenderAbi.abi
  },
};